// ─── Stripe Configuration ────────────────────────────────────────
// 1. Go to https://dashboard.stripe.com
// 2. Create a Product (e.g. "Saving Grace — Novel")
// 3. Go to Payment Links → Create a payment link for that product
// 4. Paste the link URL below (looks like https://buy.stripe.com/xxxxx)
export const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/5kQfZa8H26Tq4xBaVN3sI00';
